import React from 'react'

import { connect } from 'react-redux'
import { Col, Well, Button, Collapse, Pagination, FormGroup, InputGroup, FormControl, Glyphicon } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { changeSearchTerm, changeTagFilter, changePage, changeSort, changeUserFilter, getResourcePosts } from '../reducers/manageResourcePosts'
import { Typeahead } from 'react-bootstrap-typeahead'

class PostSidebar extends React.Component {

  state = {
    open: false
  }

  _renderMenuItemChildren = (option, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON CLIENT CONTACT SELECTION
    return [
      <div key="name" search={props.text}>
        <strong>{option.name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {option.email}
        </small>
      </div>
    ];
  }

  structurePostUrl = (post) => {
    /// TRANSLATES THE POSTS NAME AND ID INTO A URL ROUTE
    // eslint-disable-next-line
    let punctuationless = post.name.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"");
    let finalString = punctuationless.replace(/\s{2,}/g," ").toLocaleLowerCase();
    return finalString.replace(/ /g,"-");
  }

  getResourcePostsWithFilters = (page = 1) => {
    let filters, created_by, tags, search_term
    if (this.props.userFilter.length) {
      created_by = this.props.userFilter.map(user => user.user_id)
    }

    if (this.props.tagFilter.length) {
      tags = this.props.tagFilter.map(tag => tag.id)
    }

    if (this.props.searchTerm) {
      search_term = this.props.searchTerm
    }

    if (created_by || tags || search_term) {
      filters = {
          created_by,
          tags,
          search_term
        }
    }

     this.props.getResourcePosts(page, filters, this.props.sort)
  }

  handleNameInput = (e) => {
    this.props.changeSearchTerm(e.target.value)
  }

  handleTagInput = (value) => {
    this.props.changeTagFilter(value)
    this.getResourcePostsWithFilters(1)
  }

  handleChangeUserFilter = (users) => {
    this.props.changeUserFilter(users)
  }

  render () {

    let users = this.props.users.map(user => {
      return {
        name: `${user.first_name} ${user.last_name}`,
        first_name: user.first_name,
        last_name: user.last_name,
        user_id: user.id,
        client: user.department || user.client,
        email: user.email,
        title: user.title
      }
    }).sort((a,b) => a.name.localeCompare(b.name))

    return (
      <div id="PostSidebar">
        {/*------------      INPUT FIELDS FOR LARGE DEVICES      ------------*/}
        <Col xsHidden smHidden id="large-device">
          <Well id="large-device">
            <div>
              <center>
                <h4>Sort By</h4>
              </center>
              <br/>
              <FormControl
                componentClass="select"
                placeholder="Sort Projects"
                value={this.props.sort}
                onChange={(e) => this.props.changeSort(e.target.value)}
                >
                <option value="">-</option>
                <option value="-created_date">Most Recent</option>
                <option value="-views">Most Popular</option>
              </FormControl>
            </div>
            <div style={this.props.postPage ? {display: "none"} : null}>
              <br/>
              <center>
                <h4>Resource Post Filter</h4>
              </center>
              <div>
                <h5>Search Posts</h5>
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      id='resourcePostSearchTermInputLarge'
                      type="text"
                      value={this.props.searchTerm}
                      placeholder="Search name or text of posts"
                      onChange={this.handleNameInput}
                      onKeyPress={this.props.handleEnterPress}
                    />
                    <InputGroup.Button>
                      <Button
                        bsStyle={this.props.searchTerm ? "info" : "default"}
                        onClick={() => this.getResourcePostsWithFilters(1)}
                      >
                        <Glyphicon glyph="search" />
                      </Button>
                    </InputGroup.Button>
                  </InputGroup>
                </FormGroup>
              </div>
              <div>
                <h5>Uploader</h5>
                  <Typeahead
                    id="UserFilterTypeahead"
                    clearButton
                    labelKey="name"
                    multiple
                    renderMenuItemChildren={this._renderMenuItemChildren}
                    selected={this.props.userFilter}
                    options={users}
                    placeholder="Select an uploader's name"
                    onChange={this.handleChangeUserFilter}
                  />
              </div>
              <div>
                <h5>Tags</h5>
                <Typeahead
                  id="TagFilterTypeahead"
                  clearButton
                  multiple
                  labelKey="name"
                  defaultSelected={this.props.tagFilter}
                  selected={this.props.tagFilter}
                  options={this.props.tags.sort((a,b) => a.name.localeCompare(b.name))}
                  placeholder="Tag"
                  onChange={this.handleTagInput}
                  />
              </div>
            </div>
            <br/>
            <center>
              <Link to="/resource-posts/new/post">
                <Button bsStyle="primary">New Post</Button>
              </Link>
            </center>
            <div>
              {this.props.buttons && this.props.buttons.length > 1 ?
                <Pagination style={{marginBottom:"0px"}}>
                  {this.props.buttons}
                </Pagination>
                :
                null
              }
            </div>
          </Well>
        </Col>
        {/*------------      INPUT FIELDS FOR SMALL DEVICES      ------------*/}
        <Col mdHidden lgHidden>
          <div id="filter-display-button">
            <Button onClick={() => this.setState({ open: !this.state.open })}>
              Sidebar
            </Button>
          </div>
          <Collapse in={this.state.open}>
            <Well>
                <div>
                  <center>
                    <h4>Sort By</h4>
                  </center>
                  <br/>
                  <FormControl
                    componentClass="select"
                    placeholder="Sort Projects"
                    value={this.props.sort}
                    onChange={(e) => this.props.changeSort(e.target.value)}
                    >
                    <option value="">-</option>
                    <option value="-created_date">Most Recent</option>
                    <option value="-views">Most Popular</option>
                  </FormControl>
                </div>
                <div style={this.props.postPage ? {display: "none"} : null}>
                  <br/>
                  <center>
                    <h4>Resource Post Filter</h4>
                  </center>
                  <div>
                    <h5>Search Posts</h5>
                    <FormGroup>
                      <InputGroup>
                        <FormControl
                          id='resourcePostSearchTermInputSmall'
                          type="text"
                          value={this.props.searchTerm}
                          placeholder="Search name or text of posts"
                          onChange={this.handleNameInput}
                          onKeyPress={this.props.handleEnterPress}
                        />
                        <InputGroup.Button>
                          <Button
                            bsStyle={this.props.searchTerm ? "info" : "default"}
                            onClick={this.getResourcePostsWithFilters}
                          >
                            <Glyphicon glyph="search" />
                          </Button>
                        </InputGroup.Button>
                      </InputGroup>
                    </FormGroup>
                  </div>
                  <div>
                    <h5>Uploader</h5>
                      <Typeahead
                        id="UserFilterTypeahead"
                        clearButton
                        labelKey="name"
                        multiple
                        renderMenuItemChildren={this._renderMenuItemChildren}
                        selected={this.props.userFilter}
                        options={users}
                        placeholder="Select an uploader's name"
                        onChange={this.props.changeUserFilter}
                      />
                  </div>
                  <div>
                    <h5>Tag</h5>
                    <Typeahead
                      id="TagFilterTypeahead"
                      clearButton
                      labelKey="name"
                      multiple
                      defaultSelected={this.props.tagFilter}
                      selected={this.props.tagFilter}
                      options={this.props.tags.sort((a,b) => a.name.localeCompare(b.name))}
                      placeholder="Tag"
                      onChange={this.handleTagInput}
                      />
                  </div>
                </div>
                <br/>
                <Link to="/resource-posts/new/post">
                  <Button bsStyle="primary">New Post</Button>
                </Link>
            </Well>
          </Collapse>
        </Col>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    posts: state.manageResourcePosts.posts,
    tags: state.manageResourcePosts.tags,
    sort: state.manageResourcePosts.sort,
    users: state.manageLogin.users,
    searchTerm: state.manageResourcePosts.searchTerm,
    userFilter: state.manageResourcePosts.userFilter,
    tagFilter: state.manageResourcePosts.tagFilter,
  }
}

export default connect(mapStateToProps, { changeSearchTerm, changeTagFilter, changePage, changeSort, changeUserFilter, getResourcePosts })(PostSidebar);



// WEBPACK FOOTER //
// ./src/routes/resource-posts/components/PostSidebar.js